import { render, staticRenderFns } from "./MyServices.vue?vue&type=template&id=524cac08&scoped=true"
import script from "./MyServices.vue?vue&type=script&lang=js"
export * from "./MyServices.vue?vue&type=script&lang=js"
import style0 from "./MyServices.vue?vue&type=style&index=0&id=524cac08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524cac08",
  null
  
)

export default component.exports